import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { TRANSLATIONS_IT, TRANSLATIONS_EN } from '../constants';

@Injectable()
export class Translate {
	private currentLanguage;

	private translations_map = {
		it: TRANSLATIONS_IT,
		en: TRANSLATIONS_EN
	};
	private translations$: BehaviorSubject<any> = new BehaviorSubject<any>(TRANSLATIONS_IT);

	constructor() {
		this.currentLanguage = 'it';
	}

	setTranslations(lang: string) {
    this.currentLanguage = lang;
		this.translations$.next(this.translations_map[lang]);
	}

	getTranslations$() {
		return this.translations$;
	}

	getCurrentLanguage() {
		return this.currentLanguage;
	}
}



// WEBPACK FOOTER //
// ./src/app/services/translate.service.ts